// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d79306b","770":"8f5d5610"}[chunkId] + ".chunk.js";
};